(() => {
  const selector = 'h2.jdgm-rev-widg__title, h2.jdgm-carousel-title';

  function replaceTitle(heading) {
    const label = document.createElement('div');
    for (const attribute of heading.attributes) {
      if (attribute.name !== 'role' && attribute.name !== 'aria-level') {
        label.setAttribute(attribute.name, attribute.value);
      }
    }
    label.classList.add('h2');
    while (heading.firstChild) label.appendChild(heading.firstChild);
    heading.replaceWith(label);
  }

  function updateTitles(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches(selector)) replaceTitle(root);
    else root.querySelectorAll(selector).forEach(replaceTitle);
  }

  // Judge.me can render or replace its widget after the initial page load.
  updateTitles(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) updateTitles(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
